/*The fork of https://github.com/mapshakers/leaflet-control-window */

L.Control.Window = L.Control.extend({

    includes: L.Evented.prototype || L.Mixin.Events,

    options: {
        element: 'map',
        className: 'control-window',
        visible: false,
        title: undefined,
        closeButton: true,
        content: undefined,
        prompt: undefined,
        maxWidth: 600,
        minWidth: 200,
        modal: false,
        position: 'center'
    },
    initialize: function (map, options) {

        //modified by Wormix, window redraw ability has been added on map resizing
        this.map = map;
        /*
        if (map.hasOwnProperty('options')) {
            container = map.getContainer();
        } else {
            container = map;
        }
        */
        options.element = map.getContainer();
        //options.element = container;

        L.setOptions(this, options);

        var modality = 'nonmodal';

        if (this.options.modal)
            modality = 'modal';


        // Create popup window container
        this._wrapper = L.DomUtil.create('div',modality+' leaflet-control-window-wrapper', L.DomUtil.get(this.options.element));

        this._container = L.DomUtil.create('div', 'leaflet-control leaflet-control-window '+this.options.className,this._wrapper);
        let styles = ['max-width:'+this.options.maxWidth+'px']
        if (this.options.minWidth)
            styles.push('min-width:'+this.options.minWidth+'px')
        this._container.setAttribute('style', styles.join(";"));

        this._containerTitleBar = L.DomUtil.create('div', 'titlebar',this._container);
        this.titleContent = L.DomUtil.create('h2', 'title',this._containerTitleBar);
        this._containerContent =  L.DomUtil.create('div', 'content' ,this._container);
        this._containerPromptButtons =  L.DomUtil.create('div', 'promptButtons' ,this._container);

        if (this.options.closeButton) {
            this._closeButton = L.DomUtil.create('a', 'close',this._containerTitleBar);
            this._closeButton.innerHTML = '&times;';
        }

        // Make sure we don't drag the map when we interact with the content
        var stop = L.DomEvent.stopPropagation;
        L.DomEvent
            .on(this._wrapper, 'contextmenu', stop)
            .on(this._wrapper, 'click', stop)
            .on(this._wrapper, 'mousedown', stop)
            .on(this._wrapper, 'touchstart', stop)
            .on(this._wrapper, 'dblclick', stop)
            .on(this._wrapper, 'mousewheel', stop)
            .on(this._wrapper, 'MozMousePixelScroll', stop);

        //modified by wormix, event handler has been added to fire action button event by external generated window event
        //used to start the action event from child controls
        L.DomEvent.addListener(this._container, "L.Control.Window.Action", function () {
            if (this._btnAction) {
                this._btnAction.dispatchEvent( new Event('click'));
            }
        }, this);

        L.DomEvent.addListener(this._container, "L.Control.Window.OK", function () {
            if (this._btnOk) {
                this._btnOk.dispatchEvent( new Event('click'));
            }
        }, this);

        L.DomEvent.addListener(this._container, "L.Control.Window.Cancel", function () {
            if (this._btnCancel) {
                this._btnCancel.dispatchEvent( new Event('click'));
            }
        }, this);

        // Attach event to close button
        if (this.options.closeButton) {
            var close = this._closeButton;
            //this.hide was replaced with this.close (wormix)
            L.DomEvent.on(close, 'click', this.close, this);
        }

        //modified by wormix, titleBar hide feature has been added on empty title
        if (this.options.title != null ){
            this.title(this.options.title);
        }
        if (this.options.content) {
            this.content(this.options.content);
        }
        if (typeof(this.options.prompt)=='object') {
            this.prompt(this.options.prompt);
        }
        if (this.options.visible){
            this.show();
        }

        //modified by Wormix, window redraw ability has been added on window resizing
        if (this.map) {
            map.on('resize', this.mapResized, this);
        }
    },
    disableBtn: function(){
			this._btnOk.disabled=true;
			this._btnOk.className='disabled';
	},
	enableBtn: function(){
			this._btnOk.disabled=false;
			this._btnOk.className='';
	},
    title: function(titleContent){
        if (titleContent==undefined){
            return this.options.title
        }

        this.options.title = titleContent;
        var title = titleContent || '';
        this.titleContent.innerHTML = title;
        this._containerTitleBar.hidden = title === "";
        return this;
    },
    remove: function () {

        if (this._wrapper.parentElement)
            L.DomUtil.get(this.options.element).removeChild(this._wrapper);

        // Unregister events to prevent memory leak
        var stop = L.DomEvent.stopPropagation;
        L.DomEvent
            .off(this._wrapper, 'contextmenu', stop)
            .off(this._wrapper, 'click', stop)
            .off(this._wrapper, 'mousedown', stop)
            .off(this._wrapper, 'touchstart', stop)
            .off(this._wrapper, 'dblclick', stop)
            .off(this._wrapper, 'mousewheel', stop)
            .off(this._wrapper, 'MozMousePixelScroll', stop);

        if (this.map) {
            this.map.off('resize',this.mapResized);
        }


        if (this._closeButton && this._close) {
            var close = this._closeButton;
            L.DomEvent.off(close, 'click', this.close, this);
        }
        return this;
    },
    mapResized : function(){
        if (L.DomUtil.hasClass(this._wrapper, 'visible'))
            this.show();
    },

    contentUpdated: function () {
        if (L.DomUtil.hasClass(this._wrapper, 'visible'))
            this.show();
    },

    show: function (position) {

        if (position){
            this.options.position = position
        }

        let padding = {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
        }
        let cp = this.options.padding
        if (cp) {
            if (typeof cp === "function") {
                cp = cp()
            }
            padding.top = typeof cp.top !== 'undefined' ? cp.top : padding.top
            padding.bottom = typeof cp.bottom !== 'undefined' ? cp.bottom : padding.bottom
            padding.right = typeof cp.right !== 'undefined' ? cp.right : padding.right
            padding.left = typeof cp.left !== 'undefined' ? cp.left : padding.left
        }
        L.DomUtil.addClass(this._wrapper, 'visible');

        this.setContentMaxHeight();
        var thisWidth = this._container.offsetWidth;
        var thisHeight = this._container.offsetHeight;
        var margin = 8;

        var el =  L.DomUtil.get(this.options.element);
        var rect = el.getBoundingClientRect();

        var top = rect.top + padding.top;
        var left = rect.left + padding.left;

        var width = (rect.right - left - padding.right) ||  Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var height = (rect.bottom - top - padding.bottom) ||  Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

        var offset = 0;

        // SET POSITION OF WINDOW
        if (this.options.position == 'topLeft'){
            this.showOn([left,top+offset])
            } else if (this.options.position == 'left') {
            this.showOn([left, top+height/2-thisHeight/2-margin+offset])
        } else if (this.options.position == 'bottomLeft') {
            this.showOn([left, top+height-thisHeight-margin*2-offset])
        } else if (this.options.position == 'top') {
            this.showOn([left+width/2-thisWidth/2-margin,top+offset])
        } else if (this.options.position == 'topRight') {
            this.showOn([left+width-thisWidth-margin*2,top+ offset])
        } else if (this.options.position == 'right') {
            this.showOn([left+width-thisWidth-margin*2, top+height/2-thisHeight/2-margin+offset])
        } else if (this.options.position == 'bottomRight') {
            this.showOn([left+width-thisWidth-margin*2,top+ height-thisHeight-margin*2-offset])
        } else if (this.options.position == 'bottom') {
            this.showOn([left+width/2-thisWidth/2-margin,top+ height-thisHeight-margin*2-offset])
        } else {
            this.showOn([left+width/2-thisWidth/2-margin, top+top+height/2-thisHeight/2-margin+offset])
        }

        return this;
    },
    showOn: function(point){
        this.setContentMaxHeight();
        L.DomUtil.setPosition(this._container, L.point(Math.round(point[0]),Math.round(point[1]),true));

        var draggable = new L.Draggable(this._container,this._containerTitleBar);
        draggable.enable();

        L.DomUtil.addClass(this._wrapper, 'visible');
        this.fire('show');
        return this;
    },
    hide: function (e) {
        L.DomUtil.removeClass(this._wrapper, 'visible');
        this.fire('hide');
        return this;
    },

    getContainer: function () {
        return this._containerContent;
    },
    content: function (content) {
        if (content==undefined){
            return this.options.content
        }
        if (content instanceof HTMLElement) {
            this.getContainer().innerHTML = "";
            this.getContainer().append(content);
            content.hidden = false;
        } else {
            this.getContainer().innerHTML = content;
        }
        this.options.content = this.getContainer();
        return this;
    },
    prompt : function(promptObject){

        if (promptObject == undefined){
            return this.options.prompt
        }

        this.options.prompt = promptObject;

        //it's a pretty stupid implementation in order to save the back compatibility with original behavior
        //todo need to move buttons and a common code into an array or class

        //if buttons are already defined, unregister the old callback
        if (this['_btnAction']) {
            L.DomEvent.off(this['_btnAction']);
        }
        if (this['_btnOk']) {
            L.DomEvent.off(this['_btnOk']);
        }
        if (this['_btnCancel']) {
            L.DomEvent.off(this['_btnCancel']);
        }

        //set a new promptCallback
        this.setPromptCallback(promptObject.callback); //ok button
        this.setActionCallback(promptObject.action); //action button
        this.setCancelCallback(promptObject.cancel); //cancel button

        var cancel = this.options.prompt.buttonCancel || undefined;

        var ok = this.options.prompt.buttonOK == null ? 'OK' : this.options.prompt.buttonOK;

        var action = this.options.prompt.buttonAction || undefined;

        let buttonAdd = function (name, title, callback) {
            if (title === undefined)
                return;
            let btn = '_btn'+ name.charAt(0).toUpperCase() + name.slice(1);
            //if (! this[btn]) {
                this[btn] = L.DomUtil.create('button','control-window-btn-' + name, this._containerPromptButtons);
                this[btn].innerHTML = title;
            //}
            L.DomEvent.
                on(this[btn], 'click', callback, this).
                on(this[btn], 'click', L.DomEvent.stopPropagation);
        }.bind(this);

        // remove all already exist buttons
        this._containerPromptButtons.replaceChildren()

        buttonAdd("action", action, this.action);
        if (this.options.prompt.reverseOrder) {
            buttonAdd("cancel", cancel, this.cancelCallback);
            buttonAdd("ok", ok, this.promptCallback);
        } else {
            buttonAdd("ok", ok, this.promptCallback);
            buttonAdd("cancel", cancel, this.cancelCallback);
        }
        return this;
    },
    container : function(containerContent){
        if (containerContent==undefined){
            return this._container.innerHTML
        }

        this._container.innerHTML = containerContent;

        if (this.options.closeButton) {
            this._closeButton = L.DomUtil.create('a', 'close',this._container);
            this._closeButton.innerHTML = '&times;';
            L.DomEvent.on(this._closeButton, 'click', this.close, this);
        }
        return this;

    },
    setPromptCallback : function(callback){
        var self = this;
        if (typeof(callback)!= 'function') { callback = function() {console.warn('No OK callback function specified!');}}
        var cb = function() {
            if (typeof(callback) === 'function') {
                if (callback(this))
                    this.options.hideOnAction ? self.hide() : self.close("ok");
            } else {
                this.options.hideOnAction ? self.hide() : self.close("ok");
            }
        };
        this.promptCallback = cb;
        return this;
    },
    setActionCallback : function(callback){
        var self = this;
        if (typeof(callback)!= 'function') { callback = function() {console.warn('No Action callback function specified!');}}
        var cb = function() {
            if (typeof(callback) === 'function') {
                if (callback(this))
                    this.options.hideOnAction ? self.hide() : self.close("action");
            }
        };
        this.action = cb;
        return this;
    },
    //by wormix
    setCancelCallback : function(callback) {
        var self = this;
        var cb = function() {
            if (typeof(callback) === 'function') {
                if (callback(this))
                    this.options.hideOnAction ? self.hide() : self.close("cancel");
            } else {
                this.options.hideOnAction ? self.hide() : self.close("cancel");
            }
        };
        this.cancelCallback = cb;
        return this;
    },

    setContentMaxHeight : function(){
        var margin = 68;

        if (this.options.title){
            margin += this._containerTitleBar.offsetHeight-36;
        }
        if (typeof(this.options.prompt) == 'object'){
            margin += this._containerPromptButtons.offsetHeight-20
        }

        var el =  L.DomUtil.get(this.options.element);
        var rect = el.getBoundingClientRect();
        var height = rect.bottom -rect.top;

        var maxHeight = height - margin;
        this._containerContent.setAttribute('style','max-height:'+maxHeight+'px')
    },
    // closes window and fire "close" event
    // result is sent to an event handler and usually means was the window closed with cancel button or action (OK) button
    close : function(button){
        this.hide();
        this.remove();
        this.fire('close', {button: button});
        return undefined;
    }
});

L.control.window = function (container,options) {
    return new L.Control.Window(container,options);
};
